// src/pages/admin/AdminGlobalSettings.js
// UPDATED - December 26, 2025 - Vertical tabs layout

import React, { useState } from 'react';
import {
    Box,
    Typography,
    Tabs,
    Tab,
    Paper
} from '@mui/material';
import AdminProductManagement from './AdminProductManagement';
import QuestionnaireTemplateListPage from '../../components/Admin/QuestionnaireTemplateListPage';
import UserAgreementListPage from '../../components/Admin/UserAgreementListPage';
import CreateAdminUserForm from '../../components/Admin/CreateAdminUserForm';
import IcrSchedulingSettings from '../../pages/admin/IcrSchedulingSettings';
import AiProviderSettings from '../../components/Admin/AiProviderSettings';
import AdminPlatformDefaults from '../../components/Admin/AdminPlatformDefaults';
import ThemeRegistryManagement from '../../components/Admin/ThemeRegistryManagement';

// Standard TabPanel helper component
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`settings-tabpanel-${index}`}
            aria-labelledby={`settings-tab-${index}`}
            style={{ flex: 1 }}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const AdminGlobalSettings = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Global Settings
            </Typography>
            <Paper sx={{ width: '100%', display: 'flex' }} elevation={3}>
                {/* Vertical Tabs - Left Side */}
                <Tabs
                    orientation="vertical"
                    value={tabValue}
                    onChange={handleTabChange}
                    aria-label="global settings tabs"
                    sx={{
                        borderRight: 1,
                        borderColor: 'divider',
                        minWidth: 200,
                        '& .MuiTab-root': {
                            alignItems: 'flex-start',
                            textAlign: 'left',
                            py: 1.5,
                            minHeight: 48
                        }
                    }}
                >
                    <Tab label="Product Management" id="settings-tab-0" />
                    <Tab label="Questionnaire Templates" id="settings-tab-1" />
                    <Tab label="User Agreements" id="settings-tab-2" />
                    <Tab label="Platform Defaults" id="settings-tab-3" />
                    <Tab label="Create Admin User" id="settings-tab-4" />
                    <Tab label="ICR Scheduling" id="settings-tab-5" />
                    <Tab label="AI Provider Settings" id="settings-tab-6" />
                    <Tab label="Theme Registry" id="settings-tab-7" />
                </Tabs>

                {/* Content Panels - Right Side */}
                <Box sx={{ flex: 1, overflow: 'auto' }}>
                    <TabPanel value={tabValue} index={0}>
                        <AdminProductManagement />
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        <QuestionnaireTemplateListPage />
                    </TabPanel>
                    <TabPanel value={tabValue} index={2}>
                        <UserAgreementListPage />
                    </TabPanel>
                    <TabPanel value={tabValue} index={3}>
                        <AdminPlatformDefaults />
                    </TabPanel>
                    <TabPanel value={tabValue} index={4}>
                        <CreateAdminUserForm />
                    </TabPanel>
                    <TabPanel value={tabValue} index={5}>
                        <IcrSchedulingSettings />
                    </TabPanel>
                    <TabPanel value={tabValue} index={6}>
                        <AiProviderSettings />
                    </TabPanel>
                    <TabPanel value={tabValue} index={7}>
                        <ThemeRegistryManagement />
                    </TabPanel>
                </Box>
            </Paper>
        </Box>
    );
};

export default AdminGlobalSettings;